import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Menu, X } from 'lucide-react';

function GeneticEvolution() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Header */}
      {isMobile && (
        <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
          <div className="flex items-center h-16 px-4">
            <button
              onClick={() => navigate('/btd')}
              className="flex items-center text-blue-600 hover:text-blue-800"
            >
              <ChevronLeft size={24} />
              <span>Back</span>
            </button>
            <h1 className="flex-1 text-center text-lg font-semibold mr-8">
              Genetic Evolution
            </h1>
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="text-gray-600"
            >
              {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </header>
      )}

      {/* Sidebar */}
      <aside 
        className={`
          fixed top-0 left-0 h-full bg-white shadow-lg z-40 transition-all duration-300
          ${isMobile ? (isSidebarOpen ? 'w-64' : 'w-0') : 'w-64'}
          ${isMobile && 'mt-16'}
        `}
      >
        {!isMobile && (
          <div className="p-4 border-b">
            <button
              onClick={() => navigate('/btd')}
              className="flex items-center text-blue-600 hover:text-blue-800"
            >
              <ChevronLeft size={20} />
              <span>Back to Sections</span>
            </button>
          </div>
        )}
        
        <nav className={`${isMobile && !isSidebarOpen ? 'hidden' : 'block'} mt-4`}>
          <button
            onClick={() => navigate('/btd/theory')}
            className="w-full px-4 py-3 text-left hover:bg-blue-50"
          >
            BTD Theory
          </button>
          <button
            onClick={() => navigate('/btd/agi')}
            className="w-full px-4 py-3 text-left hover:bg-blue-50"
          >
            AGI Applications
          </button>
          <button
            onClick={() => navigate('/btd/genetics')}
            className="w-full px-4 py-3 text-left bg-blue-100 text-blue-700"
          >
            Genetic Evolution
          </button>
        </nav>
      </aside>

      {/* Main Content */}
      <main 
        className={`
          transition-all duration-300
          ${isMobile ? 'mt-16 px-4' : 'ml-64 p-8'}
        `}
      >
        <div className={`
          max-w-4xl mx-auto bg-white rounded-lg shadow-md 
          ${isMobile ? 'p-4 mt-4' : 'p-8'}
        `}>
          <h1 className={`font-bold ${isMobile ? 'text-2xl mb-4' : 'text-3xl mb-6'}`}>
            BTD in Genetic Evolution - Work in progress
          </h1>

                

          
        </div>
      </main>

      {/* Mobile Overlay */}
      {isMobile && isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/20 z-30"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
    </div>
  );
}

export default GeneticEvolution;